// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file webrtc_signal.proto (package cuda_learning, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CloseSessionRequest, CloseSessionResponse, PollEventsRequest, PollEventsResponse, SendIceCandidateRequest, SendIceCandidateResponse, SignalingMessage, StartSessionRequest, StartSessionResponse } from "./webrtc_signal_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service cuda_learning.WebRTCSignalingService
 */
export const WebRTCSignalingService = {
  typeName: "cuda_learning.WebRTCSignalingService",
  methods: {
    /**
     * @generated from rpc cuda_learning.WebRTCSignalingService.StartSession
     */
    startSession: {
      name: "StartSession",
      I: StartSessionRequest,
      O: StartSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc cuda_learning.WebRTCSignalingService.SendIceCandidate
     */
    sendIceCandidate: {
      name: "SendIceCandidate",
      I: SendIceCandidateRequest,
      O: SendIceCandidateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc cuda_learning.WebRTCSignalingService.PollEvents
     */
    pollEvents: {
      name: "PollEvents",
      I: PollEventsRequest,
      O: PollEventsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc cuda_learning.WebRTCSignalingService.CloseSession
     */
    closeSession: {
      name: "CloseSession",
      I: CloseSessionRequest,
      O: CloseSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * TODO: buf lint — SignalingMessage reused as both request and response type;
     * rename to SignalingStreamRequest/SignalingStreamResponse when this RPC is next modified.
     *
     * @generated from rpc cuda_learning.WebRTCSignalingService.SignalingStream
     */
    signalingStream: {
      name: "SignalingStream",
      I: SignalingMessage,
      O: SignalingMessage,
      kind: MethodKind.BiDiStreaming,
    },
  }
} as const;

